/**
 * TYPES
 */
import {ITelephonyConfig} from 'src/aggregates/user/queries.d';


/**
 * EXPORTS
 */
export enum loginErrors
{
    AUTHENTICATION = 'authentication',
    AUTHORIZATION = 'authorization',
    UNAVAILABLE = 'unavailable',
    UNKNOWN = 'unknown'
}

export type Menus = (
    'ai' |
    'regular'
)

export enum Statuses
{
    AWAY = 'away',
    DISCONNECTED = 'disconnected',
    ONLINE = 'online'
}

export interface INotification extends NotificationOptions
{
    title: string
}

export interface IAiConfig
{
    apiKey: string;
}

export interface ICompanyConfig
{
    manageUsers: boolean;
    partner: string | null;
    telephony: ITelephonyConfig | null;
    visibility: {
        customers: {
            noWallet: boolean;
            onlyOwn: boolean;
        }
    }
}

export interface IConfig
{
    ai: IAiConfig;
    answerAlert: number;
    menu: Menus;
    messages: IQuickMessage[];
}

export interface IQuickMessage
{
    body: string;
    key: string;
}

export interface IPopupMessage
{
    level: string;
    message: string;
    title: string;
}

export interface IUserState
{
    company: number;
    companyConfig: ICompanyConfig;
    config: IConfig;
    hasUpdatePasswordError: boolean;
    hasLoadConfigError: boolean;
    hasStartError: boolean;
    hasUpdateConfigError: boolean;
    id: string;
    isAdmin: boolean;
    isAuthorized: boolean;
    isAuthorizing: boolean;
    isUpdatingPassword: boolean;
    isLoadingConfig: boolean;
    isStarting: boolean;
    isUpdatingConfig: boolean;
    loginError: loginErrors | null;
    name: string;
    notification: INotification | null;
    organization?: string;
    password: string;
    popup: IPopupMessage | null;
    photo?: string;
    rooms: string[];
    serverUrl: string;
    started: boolean;
    status: Statuses;
    username: string;
}
